// @flow

import getLeaguePrograms from './getLeaguePrograms'
import getLeagueItemTypes from './getLeagueItemTypes'

export default [
  ...getLeaguePrograms,
  ...getLeagueItemTypes,
]
